module.exports = __webpack_public_path__ + "img/marisa kirisame lunar war enchanter_sc2.998e813f.png";